import { Box } from '@chakra-ui/react';
import React from 'react';

/** Radius of the content's top-left corner, where it meets the dark frame. */
export const NAV_FRAME_RADIUS = 16;

/**
 * The dark frame behind the top bar and the menu, painted once. Both sit on it
 * transparent, and the white content, rounded at its top-left corner, shows it
 * through the curve. The lilac bloom is anchored on the frame's top-left corner,
 * so it falls across the top bar and down the menu as one light.
 */
const NavFrameBackdrop: React.FC<{ top: number }> = ({ top }) => (
  <Box
    aria-hidden
    position="fixed"
    top={`${top}px`}
    left={0}
    right={0}
    bottom={0}
    bgColor="darkNav"
    bgImage="radial-gradient(900px 520px at 0 0, {colors.navDark.veil}, {colors.navDark.veilFade} 45%, transparent 70%)"
    pointerEvents="none"
  />
);

export default NavFrameBackdrop;
